import { STATIC_PAGE } from "../gql/StaticPagesQueris";
import LoadingIcon from "@/assets/images/icons/loading-white.svg?inline";

export default {
  name: "privacy",

  data() {
    return {
      staticPage: {}
    };
  },

  apollo: {
    staticPage: {
      query: STATIC_PAGE,
      variables() {
        return {
          name: "privacy"
        };
      }
    }
  },

  components: {
    LoadingIcon
  }
};
